import "./EmergencyPharmacy.module.css";
import Header from "@/reusable_sections/Header";
import ImmediateActionRequired from "./sections/ImmediateActionRequired";
import OnlinePharmacyPortal from "./sections/OnlinePharmacyPortal";
import FindUsInTheCity from "./sections/FindUsInTheCity";
import Footer from "@/reusable_sections/Footer";
export default function EmergencyPharmacyPage() {
  return <div>
      <Header />
      <ImmediateActionRequired />
      <OnlinePharmacyPortal />
      <FindUsInTheCity />
      <Footer />
    </div>;
}